import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './HintList.css';

interface HintItem {
    label: string;
    text: string;
}

export interface HintListItems {
    items: HintItem[];
}

export class HintList extends React.PureComponent<HintListItems> {
    render() {
        const { items } = this.props;

        return (
            <div>
                {items.map(({ label, text }) => (
                    <span key={label} className={Bem.cls('hint-list', 'item')}>
                        <span className={Bem.cls('hint-list', 'label')}>
                            {label}:
                        </span>
                        <span
                            className={Bem.cls('hint-list', 'text')}
                            title={text}
                        >
                            {text}
                        </span>
                    </span>
                ))}
            </div>
        );
    }
}
